import * as React from "react";
function SvgPrint(props, svgRef) {
    return (
        <svg
            width="1em"
            height="1em"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={svgRef}
            {...props}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M3 7a1 1 0 00-1 1v8a1 1 0 001 1h3v4a1 1 0 001 1h10a1 1 0 001-1v-4h3a1 1 0 001-1V8a1 1 0 00-1-1h-3V5a1 1 0 00-.375-.78l-2.5-2A1 1 0 0014.5 2H7a1 1 0 00-1 1v4H3zm5 0h8V5.48L14.15 4H8v3zM7 9H4v6h2v-3h12v3h2V9H7zm9 11H8v-6h8v6zm-2-2h-4v-2h4v2z"
                fill="currentcolor"
            />
        </svg>
    );
}
const ForwardRef = React.forwardRef(SvgPrint);
export default ForwardRef;
